export enum TIERS {
  GOLD = 0,
  SILVER = 1,
  BRONZE = 2,
  CHRISTMAS_CHEST = 3,
  GENESIS_CHEST = 4,
}
